/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../../../../../../addons/shared/first_party_addons';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "addons": {
                            "nested": {
                              "GiftCards": {
                                "fields": {
                                  "isEnabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "firstPartyAddon": {
                                    "type": ".squareup.addons.shared.FirstPartyAddon",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": "GIFT_CARD"
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.addons?.nested?.GiftCards) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE GiftCards @ squareup/devicesettings/profiles/v2/model/settings/addons/gift_cards.proto at 19:1
 */
export const GiftCards = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.addons.GiftCards');
fixType(GiftCards);
Builder.createAndAttachToType(GiftCards);